<template>
  <div class="bind" id="bindMain">
    <section
      id="contact"
      class="form"
      style="background-color: rgba(0, 0, 0, 0)"
    >
      <div class="container">
        <div class="row">
          <div
            class="col-12 col-md-6 align-self-center text-center text-md-left"
          >
            <!-- Success Message -->
            <div
              id="bind-success-modal"
              class="row success message"
              v-if="show3"
            >
              <div class="col-12 p-0">
                <i class="icon bigger icon-check"></i>
                <h3 style="font-family: 'Microsoft JhengHei', sans-serif">
                  綁定成功
                </h3>
                <a
                  v-if="!is_EC"
                  id="finish"
                  @click="closeLiff"
                  class="btn mx-auto primary-button"
                >
                  <i class="icon-check"></i>完成
                </a>
                <a
                  v-else
                  id="finish"
                  @click="go_member"
                  class="btn mx-auto primary-button"
                >
                  <i class="icon-check"></i>完成
                </a>
              </div>
            </div>

            <!-- Validation Code Error Message -->
            <div
              id="code-error-modal"
              class="row success message"
              v-if="showVerifyError"
            >
              <div class="col-12 p-0">
                <i class="icon bigger icon-close"></i>
                <h3 style="font-family: 'Microsoft JhengHei', sans-serif">
                  驗證碼錯誤
                </h3>
                <p>請重新輸入</p>
                <a
                  id="code-error-ckeck"
                  href
                  class="btn mx-auto primary-button"
                >
                  <i class="icon-check"></i>確定
                </a>
              </div>
            </div>

            <!-- Error Message -->
            <div
              id="bind-error-modal"
              class="row success message"
              v-if="showBindError"
            >
              <div class="col-12 p-0">
                <i class="icon bigger icon-close"></i>
                <h3 style="font-family: 'Microsoft JhengHei', sans-serif">
                  綁定錯誤
                </h3>
                <p>請重新綁定或聯絡客服</p>
                <a
                  id="bind-error-ckeck"
                  href
                  class="btn mx-auto primary-button"
                >
                  <i class="icon-check"></i>確定
                </a>
              </div>
            </div>

            <!-- Error Message -->
            <div
              id="bind-error-modal"
              class="row success message"
              v-if="showSomethingError"
            >
              <div class="col-12 p-0">
                <i class="icon bigger icon-close"></i>
                <h3
                  v-if="!errorMsg.length"
                  style="font-family: 'Microsoft JhengHei', sans-serif"
                >
                  綁定異常
                </h3>
                <h3
                  v-else
                  style="font-family: 'Microsoft JhengHei', sans-serif"
                >
                  {{ errorMsg }}
                </h3>
                <template v-if="get_code_log === 1">
                  <p>請聯絡客服</p>
                  <a
                    id="bind-error-ckeck"
                    href
                    class="btn mx-auto primary-button"
                  >
                    <i class="icon-check"></i>確定
                  </a>
                </template>
              </div>
            </div>

            <!-- Steps Message -->
            <div class="row intro" v-if="!show3">
              <div class="col-12 p-0">
                <h2
                  class="featured alt"
                  style="font-family: 'Microsoft JhengHei', sans-serif"
                ></h2>
                <!-- Text 1 -->
                <div
                  v-if="
                    !(
                      show3 ||
                      showBindError ||
                      showSomethingError ||
                      showVerifyError
                    )
                  "
                >
                  <h2 id="welcome" class="featured alt"></h2>
                  <p id="text-1" v-if="show1">
                    輸入手機號碼，系統會將驗證碼以簡訊傳送給您
                  </p>
                  <p id="text-2" v-if="show2">請填入驗證碼</p>
                </div>
              </div>
            </div>

            <!-- Form -->
            <div class="row text-center">
              <div class="col-12 p-0">
                <b-form id="msform" style="height: 400px">
                  <ul
                    id="progressbar"
                    v-if="
                      !(
                        show3 ||
                        showBindError ||
                        showSomethingError ||
                        showVerifyError
                      )
                    "
                  >
                    <li id="li-1" class="active">取得驗證碼</li>
                    <li id="li-2">輸入資料</li>
                    <li id="li-3">綁定完成</li>
                  </ul>

                  <!-- Group 1 -->
                  <fieldset id="group-1" v-if="show1">
                    <div class="row">
                      <label for="name">手機號碼</label>
                    </div>
                    <div class="row">
                      <div class="col-12 input-group p-0">
                        <b-form-input
                          :state="validationPhone"
                          v-model="form.phone"
                          type="tel"
                          id="phone"
                          name="phone"
                          minlength="10"
                          maxlength="13"
                          class="form-control input-style"
                          placeholder="請輸入手機號碼"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-12 input-group p-0" @click="firstNext">
                      <a id="next-1" class="next btn primary-button">
                        下一步
                        <i class="btn-icon icon-arrow-right-circle left"></i>
                      </a>
                    </div>
                  </fieldset>

                  <!-- Group 2 -->
                  <fieldset id="group-2" v-if="show2">
                    <div class="murmur">
                      <b-icon icon="info-circle-fill" variant="info"></b-icon
                      >如無法收到驗證碼，請您諮詢客服、門市人員協助。
                    </div>
                    <div class="row">
                      <div class="col-12 input-group p-0">
                        <b-form-input
                          v-model="form.code"
                          :state="validationCode"
                          type="tel"
                          id="VerificationCode"
                          name="VerificationCode"
                          minlength="6"
                          maxlength="6"
                          class="form-control input-style"
                          placeholder="驗證碼"
                          required
                        />
                      </div>
                    </div>
                    <!-- 地址欄位 -->
                    <div v-if="custom_id=='cust_translab'" class="row">
                      <label for="gender">地址(僅用於寄送活動贈品)</label>
                    </div>
                    <div v-if="custom_id=='cust_translab'" class="row">
                      <div class="col-12 input-group p-0">
                        <b-form-input
                          v-model="form.address"
                          :state="validationAddress"
                          type="text"
                          class="form-control input-style"
                          placeholder="地址"
                          required
                        />
                      </div>
                    </div>
                    <!-- 地址欄位姓名欄位 -->
                    <div class="row">
                      <label for="user_name">姓名</label>
                    </div>
                    <div class="row">
                      <div class="col-12 input-group p-0">
                        <b-form-input
                          v-model="form.user_name"
                          :state="validationUserName"
                          id="user_name"
                          name="user_name"
                          minlength="1"
                          class="form-control input-style"
                          placeholder="請輸入姓名"
                          required
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label for="gender">性別</label>
                    </div>
                    <div class="row">
                      <div class="col-12 input-group p-0">
                        <i class="icon-arrow-down"></i>
                        <select
                          v-model="form.gender"
                          id="gender"
                          name="gender"
                          minlength="1"
                          class="form-control input-style"
                          required
                        >
                          <option value="n" selected disabled>
                            請選擇性別
                          </option>
                          <option value="m">生理男</option>
                          <option value="f">生理女</option>
                        </select>
                      </div>
                    </div>

                    <div class="row">
                      <label for="year">生日</label>
                    </div>
                    <div class="row">
                      <div class="col-4 input-group p-0">
                        <b-form-input
                          @input="yearInput"
                          v-model="form.year"
                          :state="validationYear"
                          type="tel"
                          id="year"
                          name="year"
                          minlength="4"
                          maxlength="4"
                          class="form-control input-style"
                          placeholder="西元年"
                          required
                        />
                      </div>
                      <div class="col-1 input-group p-0"></div>
                      <div class="col-3 input-group p-0">
                        <b-form-input
                          @input="monthInput"
                          v-model="form.month"
                          :state="validationMonth"
                          type="tel"
                          id="month"
                          name="month"
                          minlength="1"
                          maxlength="2"
                          class="form-control input-style"
                          placeholder="月"
                          required
                        />
                      </div>
                      <div class="col-1 input-group p-0"></div>
                      <div class="col-3 input-group p-0">
                        <b-form-input
                          v-model="form.day"
                          :state="validationDay"
                          type="tel"
                          id="day"
                          name="day"
                          minlength="1"
                          maxlength="2"
                          class="form-control input-style"
                          placeholder="日"
                          required
                        />
                      </div>
                    </div>
                    <div class="row">
                      <label for="share_code">E-mail</label>
                    </div>
                    <div class="row">
                      <div class="col-12 input-group p-0">
                        <b-form-input
                          id="share_code"
                          name="share_code"
                          v-model="form.email"
                          class="form-control input-style"
                        />
                      </div>
                    </div>
                    <div
                      class="col-12 input-group p-0 d-flex justify-content-center justify-content-md-start"
                    >
                      <a
                        id="prev-2"
                        class="previous btn primary-button mr-4"
                        @click="firstPre"
                      >
                        <i class="btn-icon icon-arrow-left-circle"></i>上一步
                      </a>
                      <a
                        id="next-2"
                        class="next btn primary-button"
                        @click="secondNext"
                      >
                        下一步
                        <i class="btn-icon icon-arrow-right-circle left"></i>
                      </a>
                    </div>
                  </fieldset>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import liff from "@line/liff";
export default {
  name: "lineRecordQA",
  data() {
    return {
      // url parameters
      IDtoken: "",
      user_id: "",
      custom_id: "",
      os: "",
      displayname: "",
      //
      APIbaseURL: "https://flowapi.theflowchat.com/platform",
      form: {
        code: "",
        user_name: "",
        gender: "n",
        year: "",
        month: "",
        day: "",
        address: "",
        phone: "",
        email: "",
      },
      show1: true,
      show2: false,
      show3: false,
      showVerifyError: false,
      showSomethingError: false,
      showBindError: false,
      token: "",
      today: new Date(),
      errorMsg: "",
      redirect_url: "",
      get_code_log: 1,
      is_EC: false,
      sending1 : false,
      sending2 : false,
    };
  },
  created() {
  },
  mounted() {
    this.get_url_params();
    //
    if (this.$route.query.name)
      document.getElementById("welcome").innerHTML = "Hi! " + this.displayname;
    if (this.$route.query.os == "web")
      document.getElementById("bindMain").innerHTML = "<p class='content'>請至智慧型手機使用相關功能！</p>";
  },
  computed: {
    validationAddress() {
      return !this.form.address == "";
    },
    validationUserName() {
      return !this.form.user_name == "";
    },
    validationPhone() {
      var reg = /^09[0-9]{8}$/;
      return reg.test(this.form.phone) && !this.form.phone == "";
    },
    validationCode() {
      var reg = /^([0-9]|[A-Z]|[a-z]){6}$/;
      return reg.test(this.form.code) && !this.form.code == "";
    },
    validationYear() {
      var reg = /^(19|20)[0-9]{2}$/;
      return (
        reg.test(this.form.year) &&
        !this.form.year == "" &&
        this.form.year <= this.today.getFullYear()
      );
    },
    validationMonth() {
      return (
        parseInt(this.form.month) > 0 &&
        parseInt(this.form.month) < 13 &&
        !this.form.month == ""
      );
    },
    validationDay() {
      return (
        parseInt(this.form.day) > 0 &&
        parseInt(this.form.day) < 32 &&
        !this.form.day == ""
      );
    },
  },
  methods: {
    get_url_params() {
      // path
      this.custom_id = this.$route.params.id;
      // query string
      this.user_id = this.$route.query.uid;
      this.os = this.$route.query.os;
      this.displayname = this.$route.query.name;
      // this.IDtoken = this.$route.query.IDtoken;
    },
    go_member() {
      this.$router.push(
        "/index?user_id=" + this.user_id + "&custom_id=" + this.custom_id + "&os=" + this.os
      );
    },
    closeLiff() {
      liff.closeWindow();
    },
    firstNext() {
      if (!this.validationPhone) return;
          document.getElementById("li-2").classList.add("active");
          this.show1 = false;
          this.show2 = true;
      // 防止重複call api
      // if (this.sending1) {
      //   return;
      // } else {
      //   this.sending1 = true
      // };

      // axios({
      //   method: "post",
      //   baseURL: this.APIbaseURL,
      //   url: "/flow/get_code",
      //   data: {
      //     phone: this.form.phone,
      //     identity: this.custom_id,
		  //     user_id: this.user_id,
      //     // IDtoken: this.IDtoken,
      //   },
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: this.token, // not required for now, not check at backend
      //   },
      // }).then((res) => {
      //   this.sending1 = false;

      //   // console.debug(res);
      //   if (res.status == 200 && res.data.log == 1) {
      //     this.token = res.data.token;
      //     document.getElementById("li-2").classList.add("active");
      //     this.show1 = false;
      //     this.show2 = true;
      //   } else {
      //     this.errorMsg = res.data.message;
      //     this.show1 = false;
      //     this.showSomethingError = true;
      //     this.redirect_url = res.data.redirect_url;
      //     this.get_code_log = res.data.log;
      //   }
      // });
    },
    firstPre() {
      document.getElementById("li-2").classList.remove("active");
      this.show1 = true;
      this.show2 = false;
    },
    secondNext() {
      if ((!this.validationAddress) && (this.custom_id=='cust_translab')){
        return;
      }
      if (!this.validationUserName) {
        return;
      }
      if (!this.validationCode){
        return;
      }
      if (!this.validationYear){
        return;
      }
      if (!this.validationMonth){
        return;
      }
      if (!this.validationDay){
        return;
      }

      // 防止重複call api
      if (this.sending2) {
        return;
      } else {
        this.sending2 = true
      };

      let jsonData = {
        token: this.token,
        user_id: this.user_id,
        custom_id: this.custom_id,
        code: this.form.code,
        
        user_name: this.form.user_name,
        gender: this.form.gender == "n" ? "s" : this.form.gender,
        birth: this.form.year + "-" + this.form.month + "-" + this.form.day,
        address: this.form.address,
        
        phone: this.form.phone,
        email: this.form.email,
      };
      // console.log(jsonData);
      axios({
        method: "post",
        baseURL: this.APIbaseURL,
        url: "/FL_verify",
        data: jsonData,
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => {
        this.sending2 = false;
        
        if (res.status == 200) {
          this.show2 = false;
          if (res.data.message == "DONE") {
            document.getElementById("li-3").classList.add("active");
            this.show3 = true;
            this.is_EC = res.data.is_EC;
          } else if (res.data.message == "verify code error") {
            this.showVerifyError = true;
          } else {
            this.showBindError = true;
          }
        } else {
          this.show2 = false;
          this.showSomethingError = true;
        }
      });
    },
    yearInput() {
      if (this.form.year.length == 4) document.getElementById("month").focus();
    },
    monthInput() {
      if (parseInt(this.form.month) > 1 || this.form.month.length == 2)
        document.getElementById("day").focus();
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/vendor/bootstrap.min.css";
@import "../assets/css/vendor/slider.min.css";
@import "../assets/css/main.css";
@import "../assets/css/vendor/icons.min.css";
@import "../assets/css/vendor/gallery.min.css";
@import "../assets/css/vendor/animation.min.css";
@import "../assets/css/default.css";
@import "../assets/css/theme-classic.css";
@import "../assets/css/theme-blue.css";

.group-1-before {
  transform: scale(1);
  position: absolute;
  opacity: 1;
}
.group-1-after {
  transform: scale(0.8);
  position: absolute;
  opacity: 0;
  display: none;
}
.murmur {
  font-size: 0.88rem;
  color: dimgray;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/lineRecordQA.vue